import { Injectable } from "@angular/core";
import { HttpClient, HttpHeaders } from "@angular/common/http";
import { Observable } from "rxjs";
import { environment } from "src/environments/environment";

@Injectable({ providedIn: "root" })
export class InventarioService {
  constructor(private http: HttpClient) {}

  public get(): Observable<any[]> {
    return this.http.get<any[]>(
      `${environment.serverUrl}api/settings/inventario/get`
    );
  }

  
  public entry(defa: any): Observable<any> {
    const options = {
      headers: new HttpHeaders({ "Content-Type": "application/json" }),
    };
    return this.http.post<any>(
      `${environment.serverUrl}api/settings/inventario/entry`,
      defa,
      options
    );
  }
  public exit(defa: any): Observable<any> {
    const options = {
      headers: new HttpHeaders({ "Content-Type": "application/json" }),
    };
    return this.http.post<any>(
      `${environment.serverUrl}api/settings/inventario/exit`,
      defa,
      options
    );
  }

}
